// Import made to reuse web media manager code and overwrite the ps4 specific logic
import { default as mediaManager } from "../../../web/manager/media/media";

export const media = {
  ...mediaManager
};
